import { Box, Grid, IconButton, Typography, Drawer } from "@material-ui/core";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
// import EditProfile from "./EditProfile";
// import EditAccountStatus from "./EditAccountStatus";
const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: "30vw",
  },
  label: {
    fontSize: "14px",
    fontWeight: 400,
    color: "#666", // Light gray for labels
  },
  value: {
    fontSize: "14px",
    fontWeight: 400, // Bold text for values
  },
  row: {
    marginTop: theme.spacing(1), // Space between rows
    // paddingBottom: "5px", // Space between rows
  },
  heading: {
    // fontSize: "1.5em",
    fontWeight: 600,
  },
  editContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  editBtn: {
    border: "2px solid black",
    minWidth: "30px",
    width: "30px",
    height: "30px",
    padding: "5px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));
export default function ViewProfile({
  user,
  departmentDetails,
  setViewDetailsDrawer,
  handleRefresh,
}) {
  // console.log("🚀 ~ ViewProfile ~ departmentDetails:", departmentDetails);
  const classes = useStyles();
  const [editMode, setEditMode] = useState(false);
  const [statusDrawer, setStatusDrawer] = useState(false);

  return (
    <Box>
      <Box className={classes.editContainer}>
        <Typography className={classes.heading}>Profile</Typography>
        {/* <IconButton
          className={classes.editBtn}
          size="small"
          onClick={() => setEditMode(true)}
        >
          <EditIcon />
        </IconButton> */}
      </Box>
      {/* <Drawer
        anchor="right"
        open={editMode}
        onClose={() => setEditMode(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }} // ✅ Removes backdrop
      >
        <EditProfile
          setEditProfile={setEditMode}
          user={user}
          departmentDetails={departmentDetails}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
        />
      </Drawer> */}

      <Grid container spacing={2}>
        {[
          { label: "Full Name", value: user.full_name || "" },
          { label: "Email", value: user.email_address || "" },
          {
            label: "Phone",
            value:
              user.phone_number === "null" ||
                user.phone_number === null ||
                user.phone_number === ""
                ? ""
                : `${user.phone_number}`,
          },
          { label: "Country of Residence", value: user.country || "" },
          { label: "Location (for time zone purpose)", value: user.location || "" },
          { label: "Employee Number", value: user.employee_number || "" },
          {
            label: "Department - Role",
            value:
              `${user.department_name} - ${user?.role_name || ""}` || "",
          },
        ].map((item, index) => (
          <Grid container item xs={12} key={index} className={classes.row}>
            <Grid item xs={5}>
              <Typography variant="body2" className={classes.label}>
                {item.label}
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography variant="body2" className={classes.value}>
                {item.value}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Box style={{ marginTop: "1em" }} className={classes.editContainer}>
        <Typography className={classes.heading}>Account Status</Typography>
        {/* <IconButton
          className={classes.editBtn}
          size="small"
          onClick={() => setStatusDrawer(true)}
        >
          <EditIcon />
        </IconButton> */}
      </Box>
      {/* <Drawer
        anchor="right"
        open={statusDrawer}
        onClose={() => setStatusDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }} // ✅ Removes backdrop
      >
        <EditAccountStatus
          setStatusDrawer={setStatusDrawer}
          status={user.account_status}
          user={user}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
        />
      </Drawer> */}

      <Grid
        item
        xs={12}
        container
        className={classes.row}
        style={{ paddingBottom: "1em" }}
      >
        <Grid item xs={5}>
          <Typography variant="body2" className={classes.label}>
            Status
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="body2" className={classes.value}>
            {user?.account_status || ""}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
